// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCTitle-module__tableBox--jJ6Xj {
  flex: 1;
  min-width: 50%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCTitle-module__tableHeader--x7mcX {
  display: grid;
  overflow: hidden;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCTitle-module__tableBody--PgBy5 {
  flex: 1;
  overflow: auto;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCTitle-module__cellTop--Kxc3J {
  border-top: thin solid #e1e3e6;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCTitle-module__cellLeft--b3LG5 {
  border-left: thin solid #e1e3e6;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCTitle-module__cell--SYSjk {
  border-right: thin solid #e1e3e6;
  border-bottom: thin solid #e1e3e6;
  min-width: 60px;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCTitle-module__cellRow--KsBkm {
  color: #343a41;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  overflow: hidden;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCTitle-module__baseSizeCell--vXeDc {
  background-color: #eff5ff;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCTitle-module__cellHd--Irrg8 {
  color: #767c84;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCTitle-module__cellCentered--vxAt1 {
  text-align: center;
  padding-top: 4px;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCTitle-module__pad--ZouZH {
  padding: 8px;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCTitle-module__fullCentered--ikEvx {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCTitle-module__cell--SYSjk .ant-input-number {
  background: none;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCTitle-module__titleBox--TL_L7 {
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCTitle-module__titleText--lyP2v {
  padding: 8px;
  flex: 1;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsMeasurementChart/MChartEntity/EditMCEntity/MChartTable/MChartTable.module.less","webpack://./src/businessServices/services/bsMeasurementChart/MChartEntity/EditMCEntity/MChartTable/MCTitle.module.less"],"names":[],"mappings":"AAEA;EACE,OAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;ACDF;ADIA;EACE,aAAA;EACA,gBAAA;ACFF;ADIA;EACE,OAAA;EACA,cAAA;ACFF;ADKA;EACE,8BAAA;ACHF;ADKA;EACE,+BAAA;ACHF;ADMA;EACE,gCAAA;EACA,iCAAA;EACA,eAAA;ACJF;ADOA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;ACLF;ADOA;EACE,yBAAA;ACLF;ADQA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ACNF;ADQA;EACE,kBAAA;EACA,gBAAA;ACNF;ADQA;EACE,YAAA;ACNF;ADSA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;ACPF;ADWA;EACE,gBAAA;ACTF;AA1DA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AA4DF;AA1DA;EDgDE,YAAA;EC9CA,OAAA;AA4DF","sourcesContent":["@border: thin solid #e1e3e6;\n\n.tableBox {\n  flex: 1;\n  min-width: 50%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.tableHeader {\n  display: grid;\n  overflow: hidden;\n}\n.tableBody {\n  flex: 1;\n  overflow: auto;\n}\n\n.cellTop {\n  border-top: @border;\n}\n.cellLeft {\n  border-left: @border;\n}\n\n.cell {\n  border-right: @border;\n  border-bottom: @border;\n  min-width: 60px;\n}\n\n.cellRow {\n  color: #343a41;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  overflow: hidden;\n}\n.baseSizeCell {\n  background-color: #eff5ff;\n}\n\n.cellHd {\n  color: #767c84;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.cellCentered {\n  text-align: center;\n  padding-top: 4px;\n}\n.pad {\n  padding: 8px;\n}\n\n.fullCentered {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n// Иначе активный столбец подсвечивает тользо заголовок\n.cell :global(.ant-input-number) {\n  background: none;\n}\n","@import \"./MChartTable.module.less\";\n\n.titleBox {\n  display: flex;\n  flex-direction: row;\n  gap: 4px;\n  align-items: center;\n}\n.titleText {\n  .pad();\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableBox": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCTitle-module__tableBox--jJ6Xj`,
	"tableHeader": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCTitle-module__tableHeader--x7mcX`,
	"tableBody": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCTitle-module__tableBody--PgBy5`,
	"cellTop": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCTitle-module__cellTop--Kxc3J`,
	"cellLeft": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCTitle-module__cellLeft--b3LG5`,
	"cell": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCTitle-module__cell--SYSjk`,
	"cellRow": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCTitle-module__cellRow--KsBkm`,
	"baseSizeCell": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCTitle-module__baseSizeCell--vXeDc`,
	"cellHd": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCTitle-module__cellHd--Irrg8`,
	"cellCentered": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCTitle-module__cellCentered--vxAt1`,
	"pad": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCTitle-module__pad--ZouZH`,
	"fullCentered": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCTitle-module__fullCentered--ikEvx`,
	"titleBox": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCTitle-module__titleBox--TL_L7`,
	"titleText": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCTitle-module__titleText--lyP2v`
};
export default ___CSS_LOADER_EXPORT___;
